import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, LineChart, Line, PieChart, Pie, Cell } from "recharts";
import { brl } from "@/lib/format";

export const GOLD = "#C5A059";
export const INK = "#262626";
export const GREY = "#D4D4D4";
export const PALETTE = [GOLD, INK, "#A3A3A3", "#E8D9B5", "#737373", "#8C6D35"];

const axis = { tick: { fill: "#737373", fontSize: 12 }, axisLine: false, tickLine: false };
const short = (v) => (v >= 1000 ? `${Math.round(v / 1000)}k` : v);
const tooltipStyle = { borderRadius: 10, border: "1px solid #E5E5E5", fontSize: 12, boxShadow: "0 8px 30px rgba(0,0,0,0.06)" };

export function BarsChart({ data, xKey, series, height = 260, testId }) {
  return (
    <div data-testid={testId} style={{ height }}>
      <ResponsiveContainer>
        <BarChart data={data} barGap={6}>
          <CartesianGrid vertical={false} stroke="#F2F2F2" />
          <XAxis dataKey={xKey} {...axis} />
          <YAxis {...axis} tickFormatter={short} width={40} />
          <Tooltip formatter={(v) => brl(v)} cursor={{ fill: "#FAF7F0" }} contentStyle={tooltipStyle} />
          {series.map((s) => (
            <Bar key={s.key} dataKey={s.key} name={s.name} fill={s.color} radius={[6, 6, 0, 0]} maxBarSize={34} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function LinesChart({ data, xKey, series, height = 260, testId }) {
  return (
    <div data-testid={testId} style={{ height }}>
      <ResponsiveContainer>
        <LineChart data={data}>
          <CartesianGrid vertical={false} stroke="#F2F2F2" />
          <XAxis dataKey={xKey} {...axis} />
          <YAxis {...axis} tickFormatter={short} width={40} />
          <Tooltip formatter={(v) => brl(v)} contentStyle={tooltipStyle} />
          {series.map((s) => (
            <Line key={s.key} type="monotone" dataKey={s.key} name={s.name} stroke={s.color} strokeWidth={s.dashed ? 1.5 : 2.5} strokeDasharray={s.dashed ? "5 5" : undefined} dot={s.dashed ? false : { r: 3, fill: s.color }} />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export function DonutChart({ data, height = 200, testId }) {
  const total = data.reduce((a, d) => a + d.value, 0);
  return (
    <div data-testid={testId}>
      <div style={{ height }}>
        <ResponsiveContainer>
          <PieChart>
            <Pie data={data} dataKey="value" nameKey="name" innerRadius="62%" outerRadius="90%" paddingAngle={2} stroke="none">
              {data.map((d, i) => <Cell key={d.name} fill={PALETTE[i % PALETTE.length]} />)}
            </Pie>
            <Tooltip formatter={(v) => brl(v)} contentStyle={tooltipStyle} />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <ul className="mt-4 space-y-2">
        {data.map((d, i) => (
          <li key={d.name} className="flex items-center justify-between text-xs">
            <span className="flex items-center gap-2 text-neutral-600">
              <span className="h-2.5 w-2.5 rounded-full" style={{ background: PALETTE[i % PALETTE.length] }} />
              {d.name}
            </span>
            <span className="font-semibold text-neutral-900">{total ? Math.round((d.value / total) * 100) : 0}%</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
